import React from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import { DataGrid } from '@mui/x-data-grid';
import {Box, Grid, Button} from '@material-ui/core';
import {Stack, Snackbar, Alert, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from '@mui/material';
import OutlinedInput from '@mui/material/OutlinedInput';
import FormControl from '@mui/material/FormControl';
import Radio from '@mui/material/Radio';
import {MetaTags} from 'react-meta-tags';
import axios from 'axios';
import Cookies from 'js-cookie';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';
import LinearProgress from '@mui/material/LinearProgress';
import Tooltip from '@mui/material/Tooltip';
import Authorization from '../components/Authorization';
import ContactDetails from './ContactDetails';
import ContactSave from './ContactSave';
import { useSelector } from 'react-redux';
import {API_URL} from '../utils/EnvVars';
import Header from "../common/HeaderMy";
//import moment from 'moment';
import '../styles/bizofficer-a.css';
import 'font-awesome/css/font-awesome.min.css';

	var vertical='top',horizontal='center';
  
  export default function Execute() {
	const navigate = useNavigate();
	const location = useLocation();
	const userObj = useSelector(state => state.userDetails);	
	const isloggedin = Cookies.get('isrwadminloggedin');
	
	const alphaArr = ['A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z'];
	const alphaBtnStyle = {marginTop:-10,marginBottom:5,padding:0,display: 'inline-block', minHeight: 30, minWidth: 30, marginRight:5};
	const alphaBtnStyleActive = {marginTop:-10,marginBottom:5,padding:0,display: 'inline-block', minHeight: 30, minWidth: 30, marginRight:5, backgroundColor:'#0c65d8', color:'#FFFFFF'};

	const childRefCaseDetails = React.useRef();
	const childRefSave = React.useRef();
	const childRefAuthorization = React.useRef();
	const [privileges, setPrivileges] = React.useState("");

	const [dataLoading, setDataLoading] = React.useState(true);

	const [filter, setFilter] = React.useState(false);
	const [keyword, setKeyword] = React.useState("");
	const [alphaFilter, setAlphaFilter] = React.useState("");
	const [deleteDialogShow, setDeleteDialogShow] = React.useState(false);
	const [selectedRow, setSelectedRow] = React.useState(0);
	const [caseObj, setCaseObj] = React.useState({});
	const [rows, setRows] = React.useState([]);
	
	const [severityAlert, setSeverityAlert] = React.useState("error");
	const [showAlert, setShowAlert] = React.useState(false);
	const [alertMessage, setAlertMessage] = React.useState("");


	// check if logged in
	React.useEffect(() => {
		if(!isloggedin){
			navigate('/login');
		}
	}, [isloggedin]);

	const columns = [
		{
			field: "Select",
			headerName: "",
			width: 90,
			sortable: false,
				renderCell: (cellValues) => {
				return (
				  <Radio 
					checked={cellValues.id === selectedRow}
					value={cellValues.id}
					name="radio-buttons"
					inputProps={{ 'aria-label': {cellValues} }}
				  />
				 )
			  }
		  },
		{ field: 'id', headerName: '#', width: 40 },
		{ field: 'contactName', headerName: 'Contact Name', width: 170, renderCell: (params) =>  (
			<Tooltip title={params.value} ><span>{params.value}</span></Tooltip>
		   ), },	
		{ field: 'mobile', headerName: 'Mobile', width: 160},
		{ field: 'phone', headerName: 'Phone', width: 160 },				
		{ field: 'email', headerName: 'Email', width: 170, renderCell: (params) =>  (
			<Tooltip title={params.value} ><span>{params.value}</span></Tooltip>
		   ), },		  
		{ field: 'accountName', headerName: 'Account Name', width: 170, renderCell: (params) =>  (
			<Tooltip title={params.value} ><span>{params.value}</span></Tooltip>
		   ), },
		{ field: 'accountNumber', headerName: 'Account Number', width: 170 },   
		{ field: 'address', headerName: 'Address', width: 170 },
		{ field: 'city', headerName: 'City', width: 170 },
		{ field: 'zipCode', headerName: 'Pin Code', width: 170 },
		{ field: 'state', headerName: 'State', width: 170 },
		{ field: 'country', headerName: 'Country', width: 170 }, 
		{ field: 'designation', headerName: 'Designation', width: 170 },
		{ field: 'department', headerName: 'Department', width: 170 },   
	    { field: 'dateOfBirth', headerName: 'Date Of Birth', width: 170 },
		/*
		{
		  field: 'fullName',
		  headerName: 'Full name',
		  description: 'This column has a value getter and is not sortable.',
		  sortable: false,
		  width: 160,
		  valueGetter: (params) =>
			`${params.getValue(params.id, 'firstName') || ''} ${
			  params.getValue(params.id, 'lastName') || ''
			}`,
		},
		*/
	  ];
	

	React.useEffect(() => {		
		if(userObj.registerId && userObj.loginId && userObj.fullName && userObj.token){
			getApiData(userObj.registerId,userObj.loginId,userObj.fullName,userObj.token);			
		}
	}, [userObj,filter,location]);

	async function getApiData(registerId,uid,fullName,token){ 
			let queryString = '';
		  if(location && location.state && location.state.filter){
				queryString += '&filter='+location.state.filter;
		  }
		  let apiUrl=API_URL+'/crm-list-contacts?keyword='+keyword+queryString+'&alphaFilter='+alphaFilter;
		  let axiosHeader = {
					'Content-Type': 'multipart/mixed',
					'device': 'web',
					'registerId': registerId,
					'uid': uid,
					'fullName': fullName,
					'token': token,
			};
			const config = {
				method: 'get',
				url: apiUrl,
				headers: axiosHeader
			}
			await axios(config)
			   .then(response => {
				setDataLoading(false);
				if(response && response.data && response.data.responseTxt==="success"){  
				 	setRows(response.data.list);	
					 setPrivileges(response.data.privileges);			 				
				}else if(response && response.data && response.data.responseTxt==="invalidtoken"){
					navigate('/invalidtoken');
				}else if(response && response.data && response.data.responseTxt==="NoAuthorization"){
					childRefAuthorization.current.handleClickOpen();
				}
			}).catch((error) => {
				  setSeverityAlert("error");
				  setShowAlert(true);
				  setAlertMessage(""+error);			
				  return false;
		  	})	
	}
  
	function saveData(opt){
		if(opt===1){
			setCaseObj(null);
			childRefSave.current.handleClickOpen();
		}else if(opt===2){
			childRefSave.current.handleClickOpen();
		}else if(opt===3){
			if(caseObj){
				childRefCaseDetails.current.handleClickOpen();
			}
		}
	}
	

	function deleteData(){
		if(caseObj && userObj.token){
			let axiosHeader = {
				headers: {
					'Content-Type': 'multipart/mixed',
					'device': 'web',
					'registerId': userObj.registerId,
					'uid': userObj.loginId,
					'fullName': userObj.fullName,
					'token': userObj.token,
				}
			}; 

		  const data = new FormData();
		  data.append('id', caseObj.autoId);
		 /// data.append('studentId', studentObj.studentId);
				 
		  axios.post(API_URL+'/crm-delete-contacts', data, axiosHeader)
				.then((response) => {
					//console.log("RESPONSE RECEIVED: ", response.data.responseTxt);
				if(response.data.responseTxt==="success"){
					setDeleteDialogShow(false);
					setSelectedRow(0);
					setCaseObj(null);
					setSeverityAlert("success");
					setShowAlert(true);
					setAlertMessage("Contact has been deleted.");
			  		setRows(response.data.list);	
					return false;
				}else{
			  		setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage("This contact could not be deleted.");			
					return false;
				}
			})
				.catch((error) => {
					setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage(""+error);			
					return false;
				})	
		}		
		
	}

	function selectRow(obj){
		if(obj && rows[obj.id-1]){			
			setSelectedRow(rows[obj.id-1].id);
			setCaseObj(rows[obj.id-1]);
		}
	}

	function search(){
		setAlphaFilter("");
		setFilter(!filter);
		navigate(location.state, {}); // reset location param
	}

	function onEnter(event){
		if(event.key === 'Enter'){
			search();
		}
	}

	function handleAlphaFilter(val){
		setAlphaFilter(val);
		setFilter(!filter);
	}

	function deleteDialogHide(){
		setDeleteDialogShow(false);
	}

	function hideAlert(){
		setShowAlert(false);
	}

	function updatedList(list) {
		setRows(list);
	}

	const handleOnCellClick = (obj) => {
		if(obj.field==='accountName'){
			setCaseObj(rows[obj.id-1]);
			if(caseObj && caseObj.accountNumber){
				window.location="accountdetail?accountNumber="+caseObj.accountNumber;
			}
		}else if(obj.field==='accountNumber'){
			setCaseObj(rows[obj.id-1]);
			if(caseObj && caseObj.accountNumber){
				window.location="accountdetail?accountNumber="+caseObj.accountNumber;
			}
		}			
	};
	
	return (
		<div> 
				<MetaTags>
            		<title>Contacts</title>
          		</MetaTags>
				
				<Header hamburger={true} pageTitle="Contacts" />
				{dataLoading?<LinearProgress />:null}

				<Box className='mainBox'>	

				    <Box mt={1} mb={1} >
							<Grid container spacing={2}>
								<Grid item md={12} xs={12} >

									<FormControl style={{width:150,marginRight:60,float:'left'}}>
										<OutlinedInput 
										 id="keywordtxt"
										 placeholder="Search"
										 value={keyword}
										 onChange={event => setKeyword(event.target.value)}
										 onKeyPress={(event)=>{onEnter(event)}}
										 style={{width:200,height:40}}
										 endAdornment={
											<InputAdornment position="end">
											<SearchIcon />
											</InputAdornment>
										  }
										 />
									</FormControl>

									<Button onClick={() => {search()}} style={{marginTop:4,float:'left',backgroundColor:'#FFF',textTransform: 'none'}} size="small" variant="contained"  >Search</Button>

									<div style={{float:'left'}}>	
										{(privileges && privileges.indexOf("create")>-1)?
											<i onClick={()=>{saveData(1)}} title="Add New" className="fa fa-plus-circle btncolor" style={{fontSize:25, marginLeft:15, cursor:'pointer'}} />
										:null}  
									{selectedRow>0?<>	
										{(privileges && ((privileges.indexOf("update")>-1 && caseObj && userObj.userId===caseObj.ownerId) || privileges.indexOf("modifyall")>-1) )?
											<i onClick={()=>{saveData(2)}} title="Edit" className="fa fa-pencil-square-o btncolor" style={{fontSize:25, marginLeft:15, cursor:'pointer'}} />
										:null}
										{(privileges && privileges.indexOf("delete")>-1)?
											<i onClick={()=>{setDeleteDialogShow(true)}} title="Delete" className="fa fa-trash btncolor" style={{fontSize:25, marginLeft:15, cursor:'pointer'}} />
										:null}
										{(privileges && privileges.indexOf("delete")>-1)?
											<i onClick={()=>{saveData(3)}} title="Detail" className="fa fa-info-circle btncolor" style={{fontSize:25, marginLeft:15, cursor:'pointer'}} />
										:null}
									</>:null}

										{/* <i onClick={()=>{window.location='caseskanban'}} title="View Kanban Format" className="fa fa-trello btncolor" style={{fontSize:30, marginLeft:15, cursor:'pointer'}} />
										<i onClick={()=>{window.location='caseskanban'}} title="View Calendar" className="fa fa-calendar btncolor" style={{fontSize:30, marginLeft:15, cursor:'pointer'}} />
										<i onClick={()=>{window.location='caseskanban'}} title="Advance Search" className="fa fa-search btncolor" style={{fontSize:30, marginLeft:15, cursor:'pointer'}} /> */}

									</div>	
								</Grid>
							</Grid>
					</Box>

				{(!location.state || (location.state && location.state.filter!=='birthdays'))?	
					<Box>
						<Grid container spacing={2}>
							<Grid item md={12} xs={12} >
							{alphaArr.map((val,i)=>(	
								<Button onClick={() => {handleAlphaFilter(val)}} style={alphaFilter===val?alphaBtnStyleActive:alphaBtnStyle} title={'filter by '+val} size="small" variant="outlined"  >{val}</Button>
							))}
							</Grid>
						</Grid>					
					</Box>
				:null}	

					<div className="tblReport" style={{height: '74vh', width: '100%' }}>
						<DataGrid
							rows={rows}
							columns={columns}
							pageSize={50}
							rowHeight={40}
							rowsPerPageOptions={[50]}
							ActionsComponent={()=>{alert('Hello')}}		
							style={{fontSize:12}}	
							onRowClick={itm => selectRow(itm)}	
							onCellClick={handleOnCellClick}		
							components={{
								NoRowsOverlay: () => (
								  <Stack height="100%" alignItems="center" justifyContent="center">
									<span style={{color:'#FF0000',fontWeight:'bold'}}>No contact found!</span>
								  </Stack>
								)}}	
						/>
					</div>

				</Box>
				
			<ContactSave dataObj={caseObj} userObj={userObj} updatedList={updatedList} fullList={true} ref={childRefSave} />
			<ContactDetails caseObj={caseObj} ref={childRefCaseDetails} />						

				<Stack spacing={2} sx={{ width: '100%' }}>
					<Snackbar open={showAlert} autoHideDuration={6000} onClose={hideAlert} anchorOrigin={{vertical,horizontal}}  >
						<Alert onClose={hideAlert} variant="filled" severity={severityAlert} sx={{ width: '100%' }}>
							{alertMessage}
						</Alert>
					</Snackbar>
				</Stack>

				<Dialog
					open={deleteDialogShow}
					onClose={deleteDialogHide}
					aria-labelledby="alert-dialog-section-title"
					aria-describedby="alert-dialog-section-description"
				>
					<DialogTitle id="alert-dialog-section-title">
						Alert
					</DialogTitle>
					<DialogContent>
					<DialogContentText id="alert-dialog-section-description">
						Are you sure, You want to delete contact.
					</DialogContentText>
					</DialogContent>
					<DialogActions>
					<Button variant="outlined" size="small" onClick={()=>{deleteDialogHide()}}>Don't Delete</Button>
					<Button variant="contained" size="small" color="secondary" onClick={()=>{deleteData()}} autoFocus>Yes, Delete</Button>
					</DialogActions>
				</Dialog>
					
				<Authorization ref={childRefAuthorization} />			
		</div>	
	);
  }